import { Injectable } from '@angular/core';
import {
  CountryLanguages,
  RegionList
} from '../../models/utils/country-language.interfaces';
import { CountryLanguageExtendedHelper } from './country-language-extended-helper';
@Injectable({
  providedIn: 'root'
})
export class CountryLanguageHelpExtension extends CountryLanguageExtendedHelper {
  getActionUrl(
    returnCode: string,
    currentPage: string,
    actionUrl: string,
    startIndex: number
  ): string {
    let currentPath;
    if (returnCode) {
      currentPath = currentPage.substring(currentPage.length);
    } else {
      currentPath = currentPage.substring(startIndex);
    }
    if (!(window.location.hostname === 'localhost')) {
      actionUrl += currentPath;
    }
    return actionUrl;
  }

  getRegionForCountryCode(countryCode: string): RegionList | null {
    const normalizedCode = countryCode.toLowerCase();
    if (!this.regionList) return null;

    const country = this.getCountryForCountryCode(normalizedCode);
    if (!country) return null;

    return this.findMatchingRegion(country);
  }

  private findMatchingRegion(country: CountryLanguages): RegionList | null {
    for (const item of this.regionList) {
      const result = this.getItem(item, country);
      if (result) return result;
    }
    return null;
  }

  private getItem(
    item: RegionList,
    country: CountryLanguages
  ): RegionList | null {
    for (const regionCode of item.region_codes) {
      if (country.regionCode === regionCode) {
        return item;
      }
    }
    return null;
  }

  getReqdLangWithActionUrl(actionUrl: string, language: string): string {
    if (this.languageList.length > 0) {
      this.reqdLanguage = this.languageList[0].languageDtls.filter((item) => {
        return item.languageCode === language;
      });
      if (this.reqdLanguage?.length > 0) {
        actionUrl = this.reqdLanguage[0].url;
      }
    }
    return actionUrl;
  }

  isLanguageSupportedByCountry(
    countryCode: string,
    languageCode: string
  ): boolean {
    languageCode = languageCode.toLowerCase();
    const isLang = languageCode && languageCode !== '' ? true : false;
    return this.checkCountryLangList(isLang, countryCode, languageCode);
  }

  checkCountryLangList(
    isLang: boolean,
    countryCode: string,
    languageCode: string
  ): boolean {
    countryCode = countryCode.toLowerCase();
    if (this.countryLanguageList && isLang) {
      const country = this.getCountryForCountryCode(countryCode);
      if (country) {
        return this.checkCountry(country, languageCode);
      }
    }
    return false;
  }

  checkCountry(country: CountryLanguages, languageCode: string): boolean {
    if (country.languageDtls && country.languageDtls.length > 0) {
      const language = country.languageDtls.filter((item) => {
        return item.languageCode === languageCode;
      });
      if (language.length > 0) {
        return true;
      }
    }
    return false;
  }

  getCountryLanguageList(): CountryLanguages[] {
    return this.countryLanguageList;
  }
}
